import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SimpleInput from 'components/SimpleInput';
import CheckBox from 'components/CheckBox';
import TextArea from 'components/TextArea';
import RadioButtons from 'components/RadioButtons';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../../../reducers';

class FinalChecks extends Resetter(Validator(React.Component)) {
  state = {
    hardSurfaceHomeTemp: this.props.hardSurfaceHomeTemp || '',
    hardSurfaceAllMaterialsOnsite: this.props.hardSurfaceAllMaterialsOnsite || '',
    hardSurfaceMaterialDamage: this.props.hardSurfaceMaterialDamage || '',
    hardSurfaceMaterialDamageDetails: this.props.hardSurfaceMaterialDamageDetails || 'No damage to product',
    siteDamageInstaller: this.props.siteDamageInstaller,
    siteDamageCustomer: this.props.siteDamageCustomer,
    siteDamageDetails: this.props.siteDamageDetails || 'No existing damage',
    errors: {},
  };

  finalChecksRef = React.createRef();

  componentDidMount = () => this.finalChecksRef.current.scrollIntoView(false);

  handleSubmit = () => {
    const { hardSurfaceHomeTemp, hardSurfaceAllMaterialsOnsite, hardSurfaceMaterialDamage,
      hardSurfaceMaterialDamageDetails, siteDamageInstaller, siteDamageCustomer,
      siteDamageDetails } = this.state;
    this.props.updateFormData({
      hardSurfaceHomeTemp,
      hardSurfaceAllMaterialsOnsite,
      hardSurfaceMaterialDamage,
      hardSurfaceMaterialDamageDetails,
      siteDamageInstaller,
      siteDamageCustomer,
      siteDamageDetails,
      tab: 6,
    });
  }

  handlePrevious = () => {
    const tab = this.props.step === 'pre' ? 3 : 4;
    const { hardSurfaceHomeTemp, hardSurfaceAllMaterialsOnsite, hardSurfaceMaterialDamage,
      hardSurfaceMaterialDamageDetails, siteDamageInstaller, siteDamageCustomer,
      siteDamageDetails } = this.state;
    this.props.updateFormData({
      hardSurfaceHomeTemp,
      hardSurfaceAllMaterialsOnsite,
      hardSurfaceMaterialDamage,
      hardSurfaceMaterialDamageDetails,
      siteDamageInstaller,
      siteDamageCustomer,
      siteDamageDetails,
      tab,
    });
  }

  handleHardSurfaceHomeTemp = e => this.setState({ hardSurfaceHomeTemp: e.target.value });

  handleHardSurfaceAllMaterialsOnsite = value =>
    this.setState({ hardSurfaceAllMaterialsOnsite: value });

  handleHardSurfaceMaterialDamage = value => this.setState({ hardSurfaceMaterialDamage: value });

  handleHardSurfaceMaterialDamageDetails = e =>
    this.setState({ hardSurfaceMaterialDamageDetails: e.target.value });

  handleSiteDamageDetails = e => this.setState({ siteDamageDetails: e.target.value });

  handleSiteDamageInstaller = () =>
    this.setState({ siteDamageInstaller: !this.state.siteDamageInstaller });

  handleSiteDamageCustomer = () =>
    this.setState({ siteDamageCustomer: !this.state.siteDamageCustomer });

  render = () => {
    const { isSpanish, step, surfaceType } = this.props;
    const {
      errors,
      siteDamageInstaller,
      siteDamageCustomer,
      siteDamageDetails,
      hardSurfaceHomeTemp,
      hardSurfaceAllMaterialsOnsite,
      hardSurfaceMaterialDamage,
      hardSurfaceMaterialDamageDetails,
    } = this.state;

    const buttons = [{
      label: `${isSpanish ? 'SI' : 'YES'}`,
      value: 'yes',
    }, {
      label: 'NO',
      value: 'no',
    }];

    return (<div ref={this.finalChecksRef}>
      <h6>
        {isSpanish ? 'Controles Finales y Firmas' : 'Final Checks and Signatures'}
      </h6>

      {step === 'pre' && surfaceType === 'hard_surface' && <span>
        <SimpleInput
          label={isSpanish
            ? 'Temperatura a la llegada'
            : 'Temperature Upon Arrival'
          }
          required
          text={hardSurfaceHomeTemp}
          errors={errors.hardSurfaceHomeTemp}
          onChange={this.handleHardSurfaceHomeTemp}
        />
        <RadioButtons
          onChange={this.handleHardSurfaceAllMaterialsOnsite}
          selectedValue={hardSurfaceAllMaterialsOnsite}
          radioButtons={buttons}
          text={isSpanish
            ? '¿TODO el material está en el sitio para completar el trabajo?'
            : 'Is ALL material onsite to complete the job?'
          }
        />
        <RadioButtons
          onChange={this.handleHardSurfaceMaterialDamage}
          selectedValue={hardSurfaceMaterialDamage}
          radioButtons={buttons}
          text={isSpanish
            ? '¿Hay algún daño en los materiales?'
            : 'Is there any damage to the materials?'
          }
        />
        <TextArea
          label={isSpanish
            ? 'Detalles de daños materiales'
            : 'Material Damage Details'
          }
          value={hardSurfaceMaterialDamageDetails}
          errors={errors.hardSurfaceMaterialDamageDetails}
          onChange={this.handleHardSurfaceMaterialDamageDetails}
          autoFocus
        />
      </span>}
      {step === 'pre' ? (<span>
        <TextArea
          label={isSpanish
            ? '¿Daños en muebles, paredes, zócalos, escaleras, etc.?'
            : 'Damage to furniture, walls, baseboards, stairs, etc?'
          }
          value={siteDamageDetails}
          errors={errors.siteDamageDetails}
          onChange={this.handleSiteDamageDetails}
          autoFocus
        />
        <CheckBox
          required
          text={isSpanish
            ? 'El instalador confirmó el daño existente'
            : 'Installer confirmed existing damage'
          }
          errors={errors.siteDamageInstaller}
          onChange={this.handleSiteDamageInstaller}
          checked={siteDamageInstaller}
        />
        <CheckBox
          required
          text={isSpanish
            ? 'El cliente confirmó el daño existente'
            : 'Customer confirmed existing damage'
          }
          errors={errors.siteDamageCustomer}
          onChange={this.handleSiteDamageCustomer}
          checked={siteDamageCustomer}
        />
      </span>) : (<h4 className={S.emptyModal}>
        {isSpanish
          ? 'No se necesita información adicional, continúe con las firmas'
          : 'No additional info needed, continue on to signatures'
        }
      </h4>)}
      <Button
        label={isSpanish ? 'Próximo' : 'Next'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handleSubmit}
      />
      <Button
        label={isSpanish ? 'Anterior' : 'Previous'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handlePrevious}
      />
    </div>);
  }
}

FinalChecks.propTypes = {
  isSpanish: PropTypes.bool,
  step: PropTypes.string,
  surfaceType: PropTypes.string,
  hardSurfaceHomeTemp: PropTypes.string,
  hardSurfaceAllMaterialsOnsite: PropTypes.string,
  hardSurfaceMaterialDamage: PropTypes.string,
  hardSurfaceMaterialDamageDetails: PropTypes.string,
  siteDamageInstaller: PropTypes.bool,
  siteDamageCustomer: PropTypes.bool,
  siteDamageDetails: PropTypes.string,
  errors: PropTypes.shape({
    hardSurfaceAllMaterialsOnsite: PropTypes.arrayOf(PropTypes.string),
    hardSurfaceMaterialDamage: PropTypes.arrayOf(PropTypes.string),
    hardSurfaceMaterialDamageDetails: PropTypes.arrayOf(PropTypes.string),
    siteDamageInstaller: PropTypes.arrayOf(PropTypes.string),
    siteDamageCustomer: PropTypes.arrayOf(PropTypes.string),
    siteDamageDetails: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(FinalChecks);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/finalChecks.jsx